export default __webpack_public_path__ + "static/nav-banner-car-77cc092ed77dee0eaaed0eeb5af2e28b.png";